import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
// import MBAApplicationStepBar from "./MBAApplicationStepBar";

const STATS = [
  { num: "6", label: "Pathways" },
  { num: "3", label: "Cohorts" },
  { num: "10k+", label: "Alumni" },
];

const MBAApplicationHeader = () => (
  <header className="mba-header-section pb-0 w-full relative">
    <HeaderNavigation bgdark />
    <div className="container mx-auto px-4 pt-8 pb-10">
      <div className="flex flex-wrap lg:justify-between items-center gap-8">
        <div className="w-full lg:w-7/12">
          <span
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-secondary border-opacity-40 text-secondary text-xs font-semibold uppercase tracking-wider mb-5"
            style={{ backgroundColor: "rgba(251,175,27,0.1)" }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-secondary animate-pulse" />
            Now Accepting Applications
          </span>
          <h1 className="font-mono font-bold text-3xl md:text-4xl xl:text-5xl text-white leading-tight mb-4">
            MiniMBA
            <span className="block text-secondary">Application Form</span>
          </h1>
          <p className="text-white text-opacity-70 text-base leading-relaxed lg:w-10/12">
            Join the next generation of business leaders. Complete your
            application below to secure your spot in the programme.
          </p>
        </div>
        <div className="flex gap-4 lg:gap-6">
          {STATS.map((s, i) => (
            <div
              key={i}
              className="border border-white border-opacity-10 rounded-xl px-5 py-4 text-center"
              style={{ backgroundColor: "rgba(255,255,255,0.07)" }}
            >
              <p className="font-mono font-bold text-2xl text-secondary leading-none mb-1">
                {s.num}
              </p>
              <p className="text-white text-opacity-50 text-xs uppercase tracking-wider">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
    {/* <MBAApplicationStepBar current={currentStep} /> */}
  </header>
);

export default MBAApplicationHeader;
